import { Component } from '@angular/core';

@Component({
  selector: 'tab-panel-content',
  templateUrl: './tab-panel-content.component.html',
  styleUrls: ['./tab-panel-content.component.scss']
})
export class TabPanelContentComponent {
}
